export function idCenter(id_center) {
  const isProduction = window.themeVariables?.environment?.isProduction || "";
  return `${id_center}${isProduction ? "" : "-TR"}`;
}
